import { render } from "./AccountPayable.vue?vue&type=template&id=226436d0&ts=true"
import script from "./AccountPayable.vue?vue&type=script&lang=ts"
export * from "./AccountPayable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__